import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IApplication } from "../types/ApplicationTypes";

interface IApplicationState {
  applications: IApplication[];
  isLoading: boolean;
  error: string;
}

const initialState: IApplicationState = {
  applications: [],
  isLoading: false,
  error: "",
};

export const applicationSlice = createSlice({
  name: "application",
  initialState,
  reducers: {
    applicationLoading(state) {
      state.applications = [];
      state.isLoading = true;
      state.error = "";
    },

    applicationSuccess(state, action: PayloadAction<IApplication[]>) {
      state.applications = action.payload;
      state.isLoading = false;
      state.error = "";
    },

    applicationFailed(state, action: PayloadAction<string>) {
      state.applications = [];
      state.isLoading = false;
      state.error = action.payload;
    },

    applicationReset(state) {
      state.applications = [];
      state.isLoading = false;
      state.error = "";
    },
  },
});

export default applicationSlice.reducer;
